export interface TimeOpenResult {
  duration: number;
  formatted: string;
  color: 'green' | 'amber' | 'red';
  isOverSLA: boolean;
}

const SLA_THRESHOLD_HOURS = 48;
const WARNING_THRESHOLD_HOURS = 24;

export const calculateTimeOpen = (createdAt: string | Date, updatedAt?: string | Date, status?: string): TimeOpenResult => {
  const startTime = new Date(createdAt).getTime();
  const endTime = status === 'resolved' || status === 'rejected' 
    ? new Date(updatedAt || createdAt).getTime()
    : Date.now();
  
  const durationMs = endTime - startTime;
  const durationHours = durationMs / (1000 * 60 * 60);
  const durationDays = Math.floor(durationHours / 24);
  const remainingHours = Math.floor(durationHours % 24);
  const remainingMinutes = Math.floor((durationMs % (1000 * 60 * 60)) / (1000 * 60));

  let formatted = '';
  if (durationDays > 0) {
    formatted = `${durationDays}d ${remainingHours}h`;
  } else if (durationHours >= 1) {
    formatted = `${remainingHours}h ${remainingMinutes}m`;
  } else {
    formatted = `${remainingMinutes}m`;
  }

  let color: 'green' | 'amber' | 'red' = 'green';
  let isOverSLA = false;

  if (durationHours >= SLA_THRESHOLD_HOURS) {
    color = 'red';
    isOverSLA = true;
  } else if (durationHours >= WARNING_THRESHOLD_HOURS) {
    color = 'amber';
  }

  return {
    duration: durationHours,
    formatted,
    color,
    isOverSLA,
  };
};
